import { render, staticRenderFns } from "./mapaaproveitamentotrimestral.vue?vue&type=template&id=305d6134&"
import script from "./mapaaproveitamentotrimestral.vue?vue&type=script&lang=js&"
export * from "./mapaaproveitamentotrimestral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports